import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { ScrollReveal } from "./ScrollReveal";

export const FinalCTASection = () => {
  return (
    <section className="py-12 md:py-24 relative" style={{ background: "#FAFAFA" }}>
      <div className="container mx-auto px-4 md:px-6 relative z-10 text-center">
        <ScrollReveal>
          <h2 className="font-display font-bold mb-4 md:mb-6 leading-tight" style={{ color: "#111827", fontSize: "clamp(24px, 3.5vw, 40px)" }}>
            Your Audience Is Already Worth{" "}
            <span style={{ color: "#F59E0B" }}>More Than You Think.</span>
          </h2>
          <p className="text-sm md:text-lg max-w-2xl mx-auto mb-8 md:mb-10" style={{ color: "#4B5563" }}>
            Stop waiting to "get big enough." Start building income from the audience you already have.
          </p>
          <div className="flex flex-col items-center justify-center gap-3">
            <a href="#pricing" className="inline-block w-full md:w-auto">
              <Button variant="hero" size="xl" className="group text-base md:text-lg px-8 py-5 md:px-12 md:py-6 w-full md:w-auto max-w-[400px] btn-interactive">
                Start Your Free Trial — $0 Today
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Button>
            </a>
            <p className="text-sm" style={{ color: "#9CA3AF", fontSize: "14px" }}>
              No credit card required. 7-day free trial. Cancel anytime.
            </p>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};
